// JOBE-0162.4: RosterSkeleton — promoted from the JOBE-0162.1 inline helper.
//
// Renders `count` placeholder rows; each row carries two pencil-toned
// `StatusPill` shells (one for the name, one for the role) so the dashed
// border + pencil ink unambiguously distinguishes the skeleton from real
// content (screen-guide.md §W7).
//
// Wraps the list with `aria-busy="true"` so screen readers announce the
// loading state correctly.

import React from 'react';
import { StatusPill } from '../components/StatusPill/StatusPill.jsx';

/**
 * @param {object} [props]
 * @param {number} [props.count=8]
 */
export function RosterSkeleton({ count = 8 }) {
  return (
    <ul
      className="org-skeleton"
      data-testid="org-skeleton"
      aria-busy="true"
    >
      {Array.from({ length: count }, (_, i) => (
        <li key={i} className="org-skeleton-row">
          <StatusPill tone="pencil" label="" />
          <StatusPill tone="pencil" label="" />
        </li>
      ))}
    </ul>
  );
}
